import PropTypes from 'prop-types';
import React from 'react';

class ActionLink extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick(event) {
        try {
            var url = this.props.href;
            if (typeof ga === `function`) {
                ga('send', 'event', 'outbound', 'click', url, {
                    'transport': 'beacon',
                    'hitCallback': function () { document.location = url; }
                })
                event.preventDefault();
                return;
            } 
        } catch (error) {
            console.error(erro);
        }
    }

    render() {
        return (
            <a className={this.props.className} href={this.props.href}>{this.props.children}</a>
        );
    }
}

ActionLink.displayName = 'ActionLink';
ActionLink.propTypes = {
    href: PropTypes.string,
};

export default ActionLink;


// WEBPACK FOOTER //
// ./src/components/actionlink/ActionLink.jsx